import type { MeResponse } from '../widget-api/auth-me';

// Персона «тренер fitness» (bool + runtime view): `fitness-trainer-persona.ts`.

/** Канон `staff` + алиас `trainer` (та же org staff base line). */
export function isOrgStaffBaseRoleLine(role: string | null | undefined): boolean {
  if (role == null || role === '') return false;
  const r = role.toLowerCase();
  return r === 'staff' || r === 'trainer';
}

/** Источник правды для маршрутизации — ответ GET /auth/me, не только кеш embedMode в storage. */
export function isTrainerStaffMe(me: MeResponse | null): boolean {
  if (!me) return false;
  return isOrgStaffBaseRoleLine(me.role) || isTrainerMembershipInCurrentOrg(me);
}

/**
 * Доступ в раздел тренера по контексту токена (`me.context.surface === 'trainer'`).
 * Роль может быть trainer, staff, org_main_admin, superadmin, platform_staff.
 * Старые сессии без контекста — прежняя логика по роли.
 */
export function isTrainerSurfaceMe(me: MeResponse | null): boolean {
  if (!me) return false;
  const surface = me.context?.surface;
  if (surface) return surface === 'trainer';
  return isTrainerStaffMe(me);
}

/** Контекст платформы в приложении тренера: суперадмин/персонал платформы без студии. */
export function isPlatformTrainerContext(me: MeResponse | null): boolean {
  if (!me?.context || me.context.surface !== 'trainer') return false;
  if (me.context.org_id !== 0) return false;
  const role = me.context.role.trim().toLowerCase();
  return role === 'superadmin' || role === 'platform_staff';
}

/** Суперадмину нужно выбрать студию: платформенный контекст ещё не привязан к организации. */
export function needsTrainerStudioSelection(me: MeResponse | null): boolean {
  return isPlatformTrainerContext(me) && me?.organization_id == null;
}

/**
 * В клиентской сессии JWT роль часто `client`, даже если в организации у пользователя членство staff/trainer.
 * Ссылка «Тренеру» показывается только при активном членстве в текущей организации (привязка к филиалам — staff_branch_placements на бэкенде).
 */
export function isTrainerMembershipInCurrentOrg(me: MeResponse | null | undefined): boolean {
  if (!me?.organization_id) return false;
  const oid = me.organization_id;
  return me.memberships?.some((m) => m.organization_id === oid && isOrgStaffBaseRoleLine(m.role)) ?? false;
}
